import {computed, effect, Injectable, signal, WritableSignal} from "@angular/core";
import {DraftStatus, NuevoProyectoItem} from "../../interfaces/proyecto.interface";
import {ErrorMessages} from "../../../shared/interfaces/personas-proyecto.interface";
import {ProyectoPerfil} from "../../interfaces/perfil.interface";


@Injectable({
    providedIn: 'root'
})
export class DraftProjectService {
    draftProject: WritableSignal<NuevoProyectoItem> = signal({
        idProyecto: 0,
        nombre: "",
        numeroExpediente: "",
        usuario: "",
        idInstitucion: 0,
        descripcion: "",
        idNaturaleza: "",
        idTipoProyecto: "",
        idEntorno: "",
        idRegimen: "",
        idTipoUsoSuelo: "",
        idCobertura: "",
        idRelieve: "",
        direccion: {
            complemento: '', complemento2: '', idProyecto: 0, idMunicipio: 0, usuarioCreaModifica: '',
            estado: false, matricula: '', claveCatastral: '', latitud: '', longitud: ''
        },
        departamento: {id: '', descripcion: '', estado: false, regulado: false},
        distrito: {idDistrito: 0, descripcion: ''},
        session: {usuario: '', documento: '', correo: '', uniqueId: ''},
        ubicacionItem: {matricula: '', claveCatastral: '', latitud: 0, longitud: 0},
        elementosTerreno: [],
        areas: [],
        colindantes: [],
        tenenciaLegal: [], //obtiene la informacion de tenencia, representante legal, profesionales planos
        idTitular: '',
        montoInversion: 0
    })
    draftStatus:WritableSignal<DraftStatus> = signal({idStepRefresh:0, fecha:''})
    mensajes: ErrorMessages[] = [];
    _validateFileReload: WritableSignal<number> = signal(0);
    existeTenencia: WritableSignal<ProyectoPerfil[]> = signal([]);
    countTenenciaByStep: WritableSignal<number> = signal(0);
    _isReloadFile: WritableSignal<boolean> = signal(false);
    checkSeleted =   signal<boolean>(false);
    validateFileReload = computed(() => {
        return this._validateFileReload()});
    constructor() {
    }

    errores(paso: number) {
        if (paso == 2) {
            this.mensajes = [
                {
                    id: 1,
                    type: 'error',
                    value: 'Datos del propietario son requeridos, para continuar con el proceso seleccionar tenencia del inmueble y tipo de documento e ingresar número de documento',
                    estado: true,
                    order: 1
                }
            ];
        }
        if (paso == 3) {
            this.mensajes = [
                {
                    id: 1,
                    type: 'error',
                    value: 'Datos del representante legal son requeridos, para continuar con el proceso seleccionar tipo de documento e ingresar número de documento',
                    estado: true,
                    order: 1
                }
            ];
        }
        if (paso == 4) {
            this.mensajes = [
                {
                    id: 1,
                    type: 'info',
                    value: 'Datos de profesionales planos opcional',
                    estado: true,
                    order: 1
                }
            ];
        }
        return this.mensajes;
    }

    resetDratfProject(): NuevoProyectoItem {
        return {
            idProyecto: 0,
            nombre: "",
            numeroExpediente: "",
            usuario: "",
            idInstitucion: 0,
            descripcion: "",
            idNaturaleza: "",
            idTipoProyecto: "",
            idEntorno: "",
            idRegimen: "",
            idTipoUsoSuelo: "",
            idCobertura: "",
            idRelieve: "",
            direccion: {
                complemento: '',
                complemento2: '',
                idProyecto: 0,
                idMunicipio: 0,
                usuarioCreaModifica: '',
                estado: false,
                matricula: '',
                claveCatastral: '',
                latitud: '',
                longitud: ''
            },
            departamento: {
                id: '',
                descripcion: '',
                estado: false,
                regulado: false
            },
            distrito: {
                idDistrito: 0,
                descripcion: ''
            },
            session: {
                usuario: '',
                documento: '',
                correo: '',
                uniqueId: ''
            },
            ubicacionItem: {
                matricula: '',
                claveCatastral: '',
                latitud: 0,
                longitud: 0
            },
            elementosTerreno: [],
            areas: [],
            colindantes: [],
            tenenciaLegal: [],
            idTitular: '',
            montoInversion:0
        };
    }
    verificarAchivosTenencia(event: string): number {
        if (this.draftProject().tenenciaLegal.length > 0) {
            if (event == 'completar') {//existen valores con pageRefresh == true que indica que en el proceso se recargo la pagina o se actualizo
                let tenencia = this.draftProject().tenenciaLegal.some(draftTenencia => draftTenencia?.pageRefresh == true);
                if (tenencia) {
                    this._validateFileReload.set(1);
                } else {
                    this._validateFileReload.set(0);
                }
            }
            if (event == "refreshPage") {//se asigna a pageRefresh = true cuando se invoca en la funcion que detecta que se recargo la pagina mediante en el evento @HostListener
                this.draftProject.update(draft => ({
                    ...draft,
                    tenenciaLegal: draft.tenenciaLegal.map((item) => ({...item, pageRefresh: true}))
                }));
                this._validateFileReload.set(2);
            }
        }
        return this._validateFileReload();
    }

    get isReloadFile(): WritableSignal<boolean> {
        return this._isReloadFile;
    }
    set isReloadFile(value: WritableSignal<boolean>) {
        this._isReloadFile = value;
    }
}
